// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"b29a67d0","977":"724c90dd"}[chunkId] + ".chunk.js";
};